import * as TYPES from '../types';

const initialState = {
    bannersList: [],
};

export function BannerReducer(state = initialState, action) {
    const preState = { ...state };
    const { type, payload } = action;
    switch (type) {
        case TYPES.GET_ALL_BANNER_SUCCESS:
            return {
                ...preState,
                bannersList: payload,
            };

        default:
            return state;
    }
}